import React from "react";
import { IconProps } from "../icon";

export const Toggle_02RightIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M14 16H6a4 4 0 010-8h8m8 4a5 5 0 11-10 0 5 5 0 0110 0z"
    />
  </svg>
);
